import { Link } from "react-router-dom";
import {
  HeadingTitle,
  SubHeadingTitle,
  Button,
  Image,
} from "../../../components/shared/index";
import styles from "./aboutus.module.css";
const Store = () => {
  return (
    <>
      <section className={styles.store__wrapper}>
        <div className={styles.textContent}>
          <HeadingTitle
            text={
              <>
                <span className={styles.highlight}> Welcome to GD Mart</span>
                <br />
              </>
            }
            style={styles.heading}
          />

          <SubHeadingTitle
            subTitle={
              <p>
GD Mart is a modern digital grocery platform developed by GDRB Technologies to help local grocery stores build their own digital identity and reach more customers online. From convenient online ordering and secure payments to efficient delivery management and smart business tools, GD Mart brings everything together in one place. It helps store owners manage their products, orders, and daily operations with ease while giving customers a simple and reliable shopping experience. By combining technology with the convenience of local shopping, GD Mart supports businesses in growing their reach and serving their communities better.
              </p>
            }
          />

          {/* ✅ Move button here */}
          <Link to={"/shop"}>
            <Button
              type="button"
              title={"Shop Now"}
              style={styles.shopBtn}
            />
          </Link>
        </div>

        <div className={styles.imageWrapper}>
          <Image
            src="https://media.gettyimages.com/id/2281765817/photo/composition-with-assorted-organic-vegetables-and-fruits.jpg?s=612x612&w=0&k=20&c=r8UkbFA0K1FGZ4ENNwGNxgip-mSGj84BJK1wrnrneBs="
            className={styles.image}
            alt="Hiraola Jewellery"
          />
        </div>
      </section>
    </>
  );
};
export default Store; 
